









































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";

import Detail from "./detail.vue";
@Component({
  components: {
    Detail
  }
})
export default class extends Mixins(MyList) {
  @Prop() userId!: number;
  @Prop() type!: string;

  dispatchType: string = "users/player";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "球友名称", dataIndex: "player_nickname" },
    { title: "手机号", dataIndex: "player_mobile" },
    { title: "时间", dataIndex: "created_time" },
    { title: "权重", dataIndex: "weight" },
    { title: "是否升级为球友", scopedSlots: { customRender: "is_upgrade" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    if (this.type == "ai") {
      this.dispatchType = "users/aiPlayer";
    }
    this.loadData(
      {
        user_id: this.userId
      },
      false
    );
  }
}
